import React, { useEffect, useState } from "react";

/**
 * Lazy-loads the Lottie component AND fetches the JSON by URL,
 * so neither ends up in your main bundle.
 */
export default function LazyLottie({
  srcUrl,
  className,
  style,
  loop = true,
  autoplay = true,
  fallback = null,
}) {
  const [LottieComp, setLottieComp] = useState(null);
  const [animationData, setAnimationData] = useState(null);

  // 1) Load lottie-react only when this component is actually rendered
  useEffect(() => {
    let cancelled = false;

    import("lottie-react")
      .then((mod) => {
        if (!cancelled) setLottieComp(() => mod.default);
      })
      .catch((e) => console.warn("Failed to load lottie-react:", e));

    return () => {
      cancelled = true;
    };
  }, []);

  // 2) Fetch animation JSON at runtime (so it’s not bundled into JS)
  useEffect(() => {
    if (!srcUrl) return;
    let cancelled = false;

    fetch(srcUrl)
      .then((r) => r.json())
      .then((json) => {
        if (!cancelled) setAnimationData(json);
      })
      .catch((e) => console.warn("Failed to fetch lottie JSON:", e));

    return () => {
      cancelled = true;
    };
  }, [srcUrl]);

  if (!LottieComp || !animationData) return fallback;

  return (
    <LottieComp
      animationData={animationData}
      loop={loop}
      autoplay={autoplay}
      className={className}
      style={style}
    />
  );
}